<div class="login-container">
  <div class="left-section">
    <h3 class="description">
      {{ 'LOGIN.WELCOME' | transloco }}
    </h3>
  </div>

  <div class="right-section">
    <div class="welcome-text text-center my-5">
      <h3>{{ 'ACTIVATE_USER.ACTIVATE_ACCOUNT' | transloco }}</h3>
      <mat-slide-toggle class="mx-3" [(ngModel)]="showDetails">{{ 'ACTIVATE_USER.PASSWORD_REQUIREMENTS' | transloco
        }}</mat-slide-toggle>
      <form [formGroup]="activateUserForm">

        @if (!code) {
        <mat-form-field appearance="outline">
          <mat-label>{{ 'ACTIVATE_USER.ENTER_CODE' | transloco }}...</mat-label>
          <input matInput placeholder="{{code}}" formControlName="code" required>
          <mat-icon matSuffix>account_box</mat-icon>
        </mat-form-field>
        }

        <mat-form-field appearance="outline" class="width-100">
          <mat-label>{{ 'ACTIVATE_USER.NEW_PASSWORD' | transloco }}</mat-label>
          <input matInput #password required placeholder="{{ 'ACTIVATE_USER.NEW_PASSWORD' | transloco }}"
            [type]="hidePassword ? 'password' : 'text'" autocomplete="off" formControlName="password">
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if (activateUserForm.controls['password'].hasError('required') &&
          activateUserForm.controls['password'].touched) {
          <mat-error>
            {{ 'ACTIVATE_USER.ENTER_NEW_PASSWORD' | transloco }}
          </mat-error>
          }
          <mat-hint align="end" aria-live="polite">
            {{password.value.length}} / 30
          </mat-hint>
        </mat-form-field>
        <app-password-strength [passwordToCheck]="activateUserForm.value.password"
          [showRequirements]="showDetails"></app-password-strength>

        @if (code) {
        <mat-form-field appearance="outline" class="mt-3 width-100">
          <mat-label>{{ 'ACTIVATE_USER.CONFIRM_PASSWORD' | transloco }}</mat-label>
          <input matInput placeholder="{{ 'ACTIVATE_USER.CONFIRM_PASSWORD' | transloco }}"
            [type]="hideConfirmPassword ? 'password' : 'text'" autocomplete="off" formControlName="confirmedPassword"
            required>
          <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button">
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if ((activateUserForm.controls['confirmedPassword'].invalid || activateUserForm.hasError('notSame')) &&
          activateUserForm.controls['confirmedPassword'].touched) {
          <mat-error>
            {{ 'ACTIVATE_USER.SOMETHING_IS_WRONG' | transloco }}...
          </mat-error>
          }
        </mat-form-field>
        }
        <button mat-raised-button class="mt-2" (click)="activateUser()" color="primary" type="button"
          class="width-100-height-50" [disabled]="activateUserForm.invalid">
          {{ 'ACTIVATE_USER.ACTIVATE_ACCOUNT_AND_GO_TO_LOGIN' | transloco }}
        </button>
      </form>
    </div>
  </div>
</div>
<app-footer></app-footer>